var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeeUSoon = function SvgSeeUSoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 96,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5D6470",
    clipPath: "url(#see-u-soon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M101.77 46.98V71.8c0 4.78-4.35 8.65-9.72 8.65H45.72c-5.37 0-9.72-3.87-9.72-8.65V46.78"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M88.19 38.92c0 4.59-4.33 8.31-9.66 8.31s-9.66-3.72-9.66-8.31c0 4.59-4.33 8.31-9.66 8.31s-9.66-3.72-9.66-8.31c0 4.59-4.33 8.31-9.66 8.31h-.16c-5.98-.08-10.17-5.98-8.52-11.74l5.89-20.5c.6-2.42 2.28-4.04 4.17-4.04h55.55c1.91 0 3.61 1.67 4.19 4.13l5.62 20.55c1.5 5.47-2.25 11.15-7.91 11.58-.28.02-.56.03-.85.03-5.34 0-9.66-3.72-9.66-8.31zM93.09 50.74v13.24c0 1.12-.91 2.03-2.03 2.03H46.72c-1.12 0-2.03-.91-2.03-2.03V50.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F8",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M109.28 63.78c0-2.2-1.78-3.98-3.98-3.98H89.08c-2.2 0-3.98 1.78-3.98 3.98l-2.13 25.17v1.74c0 .61.49 1.1 1.1 1.1h5.71c.61 0 1.1-.49 1.1-1.1v-3.43c0-.38.31-.69.69-.69h11.24c.38 0 .69.31.69.69v3.38c0 .61.49 1.1 1.1 1.1h5.71c.61 0 1.1-.49 1.1-1.1v-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6470",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M97.19 80.47a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM97.19 66.01c.34 0 .62.28.62.63v8.21a.625.625 0 0 1-1.25-.01v-8.21c0-.34.28-.62.63-.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.12 30.47 7.51-2.77M122.5 25.33l2.76 7.51"
  })), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M11.1 56.9a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM23.46.96l-5.08 4.1a.736.736 0 0 0 .2 1.26l6.09 2.35c.53.2 1.08-.24.99-.8l-1.01-6.45a.736.736 0 0 0-1.19-.46Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "see-u-soon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h140v96H.5z"
  })))));
};
export default SvgSeeUSoon;